import React from 'react';
import { useTranslation } from 'react-i18next';
import { isIOS, isAndroid } from 'react-device-detect';
// import { imageAbsolutePath } from '../../utils/utils';
import styles from './VipContent.module.css';

// const google = imageAbsolutePath('googleBtn.svg');
// const apple = imageAbsolutePath('appleBtn.svg');

const VipContent: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.sectionVipContent}>
      <div className={styles.sectionVipItem}>
        {/* <div className="h3">{t('homePage.vipCard.title')}</div> */}
        {/* <VipCard /> */}
      </div>
      {!isIOS && !isAndroid && (
        <div className={styles.sectionVipItem}>
          <div className="h3">{t('homePage.readyToLearn.title')}</div>
          <p className={styles.vipText}>{t('homePage.readyToLearn.text1')}</p>
          <p className={styles.vipText}>{t('homePage.readyToLearn.text2')}</p>
          <p className={styles.vipText}>{t('homePage.readyToLearn.text3')}</p>
          <p className={styles.vipText}>{t('homePage.readyToLearn.text4')}</p>
        </div>
      )}
    </div>
  );
};

export default VipContent;
